import { NotificationType, NotificationStatus } from "@/types/notifications";
import { 
  ShoppingBag, 
  Users, 
  MessageSquare, 
  Package, 
  Calendar,
  CreditCard,
  Settings,
  Shield,
  Mail,
  Bell,
  Megaphone,
  TrendingUp
} from "lucide-react";

export const getNotificationIconName = (type: string, entityType?: string | null): string => {
  return getNotificationIcon(type as NotificationType);
};

export const getNotificationIcon = (type: NotificationType): string => {
  const category = getNotificationCategory(type);
  switch (category) {
    case 'orders': return 'shopping-bag';
    case 'staff': return 'users';
    case 'chat': return 'message-square';
    case 'inventory': return 'package';
    case 'reservations': return 'calendar';
    case 'payments': return 'credit-card';
    case 'system': return 'settings';
    case 'contact': return 'mail';
    case 'service': return 'bell';
    case 'marketing': return 'megaphone';
    case 'analytics': return 'trending-up';
    default: return 'bell';
  }
};

export const getNotificationCategory = (type: NotificationType): string => {
  if (type.includes('order')) return 'orders';
  if (type.includes('staff') || type.includes('user')) return 'staff';
  if (type.includes('chat') || type.includes('message')) return 'chat';
  if (type.includes('inventory')) return 'inventory';
  if (type.includes('reservation')) return 'reservations';
  if (type.includes('payment') || type.includes('subscription')) return 'payments';
  if (type.includes('system') || type.includes('update') || type.includes('maintenance')) return 'system';
  if (type.includes('contact') || type.includes('inquiry') || type.includes('demo')) return 'contact';
  if (type.includes('waiter') || type.includes('table')) return 'service';
  if (type.includes('marketing') || type.includes('newsletter') || type.includes('promotion')) return 'marketing';
  if (type.includes('analytics') || type.includes('sales') || type.includes('target')) return 'analytics';
  return 'other';
};

export const getNotificationColorClass = (type: string, status: string) => {
  // Simple color mapping based on type and status
  if (status === "unread") {
    return "bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-l-blue-500 hover:from-blue-100 hover:to-indigo-100";
  }
  
  if (type.includes("order")) {
    return "bg-gradient-to-r from-orange-50 to-red-50 border-l-4 border-l-orange-500 hover:from-orange-100 hover:to-red-100";
  }
  
  if (type.includes("payment")) {
    return "bg-gradient-to-r from-emerald-50 to-green-50 border-l-4 border-l-emerald-500 hover:from-emerald-100 hover:to-green-100";
  }
  
  if (type.includes("staff")) {
    return "bg-gradient-to-r from-blue-50 to-cyan-50 border-l-4 border-l-blue-500 hover:from-blue-100 hover:to-cyan-100";
  }
  
  if (type.includes("inventory")) {
    return "bg-gradient-to-r from-purple-50 to-violet-50 border-l-4 border-l-purple-500 hover:from-purple-100 hover:to-violet-100";
  }
  
  if (type.includes("reservation")) {
    return "bg-gradient-to-r from-indigo-50 to-blue-50 border-l-4 border-l-indigo-500 hover:from-indigo-100 hover:to-blue-100";
  }
  
  return "bg-gradient-to-r from-gray-50 to-slate-50 border-l-4 border-l-gray-500 hover:from-gray-100 hover:to-slate-100";
};

export const getNotificationBadgeColor = (type: string) => {
  if (type.includes("order")) return "bg-orange-100 text-orange-800";
  if (type.includes("payment")) return "bg-emerald-100 text-emerald-800";
  if (type.includes("staff")) return "bg-blue-100 text-blue-800";
  if (type.includes("inventory")) return "bg-purple-100 text-purple-800";
  if (type.includes("reservation")) return "bg-indigo-100 text-indigo-800";
  if (type.includes("chat")) return "bg-green-100 text-green-800";
  if (type.includes("system")) return "bg-gray-100 text-gray-800";
  return "bg-gray-100 text-gray-800";
}; 